import startInDomain from "@ext/markdown/elements/list/edit/models/orderList/logic/startInDomain";
import listCounterReset from "@ext/markdown/elements/list/render/listCounterReset";
import type React from "react";

const HTMLLi = (props: { children?: React.ReactNode }) => <li data-component="list-item">{props.children}</li>;
const HTMLListItem = (props: { children?: React.ReactNode }) => <li data-component="list-item">{props.children}</li>;
const HTMLTaskItem = (props: { children?: React.ReactNode }) => <li data-component="list-item">{props.children}</li>;
const HTMLBulletList = (props: { children?: React.ReactNode }) => (
	<ul data-component="bullet-list">{props.children}</ul>
);
const HTMLTaskList = (props: { children?: React.ReactNode }) => <ul data-component="task-list">{props.children}</ul>;
const HTMLOrderedList = ({ start, children }: { start?: unknown; children?: React.ReactNode }) => {
	const listStart = startInDomain(start);
	const counterReset = listCounterReset(listStart);
	return (
		<ol data-component="ordered-list" start={counterReset && listStart} style={counterReset && { counterReset }}>
			{children}
		</ol>
	);
};

export { HTMLBulletList, HTMLLi, HTMLListItem, HTMLOrderedList, HTMLTaskItem, HTMLTaskList };
